/* ProfessorPrints: make Rebuy product carousels look swipeable (desktop arrows, mobile hint text, one-time peek).
   Also hides the homepage collection-bubble arrows (ss-circle-menu) on touch screens. */
(function () {
  var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var T = { en: 'Swipe to browse', fr: 'Faites glisser pour parcourir', de: 'Wischen zum Stöbern' };
  var label = (T[lang] || T.en).toUpperCase();
  var touch = window.matchMedia('(hover: none)').matches;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nudged = false;
  try { nudged = sessionStorage.getItem('pp-cn') === '1'; } catch (e) {}
  var style = document.createElement('style');
  style.textContent = '@keyframes ppNudge{0%,100%{translate:0 0}40%{translate:-56px 0}}' +
    '@media (hover:none),(max-width:1023px){[class^="ppcm-btn-"]{display:none!important}}';
  document.head.appendChild(style);
  var styled = {};
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;

  function css(id) {
    var s = '#' + id + ' .splide.is-initialized';
    return s + '{position:relative}' +
      s + ' .splide__arrows{display:block!important}' +
      s + ' .splide__arrow{display:flex!important;align-items:center!important;justify-content:center!important;position:absolute!important;top:var(--pp-arrow-top,38%)!important;transform:translateY(-50%)!important;width:40px!important;height:40px!important;padding:0!important;margin:0!important;border-radius:50%!important;background:#fff!important;border:2px solid #121212!important;box-shadow:3px 3px 0 #F9CD44!important;opacity:1!important;z-index:5!important;cursor:pointer!important;transition:opacity .2s ease!important}' +
      s + ' .splide__arrow svg{width:14px!important;height:14px!important;fill:#121212!important}' +
      s + ' .splide__arrow--prev{left:2px!important}' +
      s + ' .splide__arrow--next{right:2px!important}' +
      s + ' .splide__arrow.pp-off,' + s + ' .splide__arrow:disabled{opacity:0!important;pointer-events:none!important}' +
      s + ' .splide__pagination::after{content:"' + label + ' \\2192"!important}' +
      '@media (hover:hover) and (min-width:1024px){' + s + ' .splide__pagination::after{content:none!important}' + s + ' .splide__arrow:hover{background:#F9CD44!important}}' +
      '@media (hover:none),(max-width:1023px){' + s + ' .splide__arrows{display:none!important}}' +
      s + '.pp-nudge .splide__list{animation:ppNudge 1.1s ease-in-out 1}';
  }

  function nudge(sp) {
    if (!touch || calm || nudged || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting || nudged) return;
      io.disconnect();
      nudged = true;
      try { sessionStorage.setItem('pp-cn', '1'); } catch (e) {}
      setTimeout(function () {
        sp.classList.add('pp-nudge');
        setTimeout(function () { sp.classList.remove('pp-nudge'); }, 1300);
      }, 500);
    }, { threshold: 0.5 });
    io.observe(sp);
  }

  function enhance(w) {
    var id = w.id;
    var sp = w.querySelector('.splide.is-initialized');
    if (!id || !sp) return;
    if (seen ? seen.has(sp) : sp.getAttribute('data-pp-hint')) return;
    if (seen) seen.add(sp); else sp.setAttribute('data-pp-hint', '1');
    if (!styled[id]) { styled[id] = 1; style.textContent += css(id); }
    var prev = sp.querySelector('.splide__arrow--prev');
    var next = sp.querySelector('.splide__arrow--next');
    var pag = sp.querySelector('.splide__pagination');
    function upd() {
      var pages = pag ? pag.querySelectorAll('.splide__pagination__page') : [];
      if (pages.length < 2) {
        if (prev) prev.classList.add('pp-off');
        if (next) next.classList.add('pp-off');
      } else {
        var a = Array.prototype.indexOf.call(pages, pag.querySelector('.splide__pagination__page.is-active'));
        if (prev) prev.classList.toggle('pp-off', a <= 0);
        if (next) next.classList.toggle('pp-off', a >= pages.length - 1);
      }
      var img = sp.querySelector('.splide__slide.is-visible img, .splide__slide img');
      if (img) {
        var r = img.getBoundingClientRect(), b = sp.getBoundingClientRect();
        if (r.height) sp.style.setProperty('--pp-arrow-top', Math.round(r.top - b.top + r.height / 2) + 'px');
      }
    }
    upd();
    setTimeout(upd, 800);
    if (pag) new MutationObserver(upd).observe(pag, { subtree: true, attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', upd);
    if (pag && pag.querySelectorAll('.splide__pagination__page').length > 1) nudge(sp);
  }

  function scan() {
    var ws = document.querySelectorAll('[id^="rebuy-widget-"]');
    for (var i = 0; i < ws.length; i++) enhance(ws[i]);
  }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 250); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
